import { makeStyles } from '@fluentui/react';
export const useStyles = makeStyles((theme) => ({
  container: {
    width: '70vw',
  },
  headerContainer: {
    boxShadow: `-7px 2px 13px rgba(0, 0, 0, 0.10)`,
    marginBottom: 10,
  },
  hierarchyContainer: {
    backgroundColor: theme.palette.white,
  },
  modalContainer: {
    display: 'flex',
    flexFlow: 'column nowrap',
    alignItems: 'stretch',
  },
  approvalTypeTextStyles: {
    color: theme.palette.themePrimary,
  },
  stampCLoseContainer: {
    width: 270,
    alignItems: 'center',
  },
  fixedWidth: {
    width: 250,
  },
  alignItemsCenter: {
    alignItems: 'center',
  },
  noScrollContainer: {
    overflow: 'hidden',
  },
}));
